// src/components/Editor/RawHtmlEditor.js

import React, { useState, useEffect } from 'react';
import { Box, TextField, Typography, Grid } from '@mui/material';

const RawHtmlEditor = ({ template, onUpdate, previewWidth }) => {
  const [htmlContent, setHtmlContent] = useState(template.htmlContent || '');

  useEffect(() => {
    setHtmlContent(template.htmlContent || '');
  }, [template.htmlContent]);

  const handleChange = (e) => {
    setHtmlContent(e.target.value);
    onUpdate({ ...template, htmlContent: e.target.value });
  };

  // Determine preview text color based on background
  const previewBgColor = template.backgroundColor || '#ffffff';
  const previewTextColor = previewBgColor.toLowerCase() === '#000000' ? '#ffffff' : '#000000';

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6">Raw HTML Editor</Typography>
      <Grid container spacing={2}>
        {/* Left Column: Scrollable HTML Editor */}
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              maxHeight: 400,
              overflowY: 'auto',
              border: '1px solid #ccc',
              p: 1,
            }}
          >
            <TextField
              label="HTML Code"
              multiline
              fullWidth
              value={htmlContent}
              onChange={handleChange}
              variant="outlined"
              minRows={10}
              inputProps={{ style: { color: '#000000', backgroundColor: '#ffffff' } }}
            />
          </Box>
        </Grid>

        {/* Right Column: Live Preview */}
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle1">Live Preview</Typography>
          <Box
            sx={{
              width: previewWidth,         // e.g., '375px' for mobile
              mx: 'auto',                  // center horizontally
              border: '1px solid #ccc',
              p: 2,
              minHeight: 300,
              backgroundColor: previewBgColor,
              color: previewTextColor,
              overflowX: 'hidden',         // hide horizontal scroll
              overflowY: 'auto',
              // Force images, tables, and iframes to shrink within container
              '& img': {
                maxWidth: '100%',
                height: 'auto',
              },
              '& table': {
                maxWidth: '100%',
                wordWrap: 'break-word',
                tableLayout: 'fixed',       // helps long content wrap
              },
              '& iframe': {
                maxWidth: '100%',
                height: 'auto',
              },
            }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RawHtmlEditor;
